import type React from 'react'

type Props = {
  size?: number
}

const IconArrowUpLine: React.FC<Props> = ({ size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.07812 3.24805H12.9219C13.3027 3.24805 13.625 2.92578 13.625 2.54492C13.625 2.13477 13.3027 1.8125 12.9219 1.8125H3.07812C2.66797 1.8125 2.375 2.13477 2.375 2.54492C2.375 2.92578 2.66797 3.24805 3.07812 3.24805ZM4.74805 9.81055L7.29688 7.11523V14.2344C7.29688 14.6445 7.58984 14.9375 8 14.9375C8.38086 14.9375 8.70312 14.6445 8.70312 14.2344V7.11523L11.2227 9.81055C11.3691 9.95703 11.5449 10.0156 11.75 10.0156C11.8965 10.0156 12.0723 9.95703 12.2188 9.83984C12.5117 9.57617 12.5117 9.10742 12.248 8.84375L8.49805 4.83008C8.23438 4.56641 7.73633 4.56641 7.47266 4.83008L3.72266 8.84375C3.45898 9.10742 3.45898 9.57617 3.75195 9.83984C4.04492 10.1035 4.48438 10.0742 4.74805 9.81055Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default IconArrowUpLine
